module.exports = __webpack_public_path__ + "static/media/ride-active.eb6889f1.svg";